import React from 'react';
import { Button } from 'antd';
import { HeartOutlined, HeartFilled } from '@ant-design/icons';

/**
 * Component for the favorite button on lot cards
 * @param {Object} props
 * @param {boolean} props.isFavorite - Whether the lot is favorited
 * @param {Function} props.onFavorite - Callback function when favorite button is clicked
 */
const FavoriteButton = ({ isFavorite, onFavorite }) => (
    <Button
        type="text"
        icon={isFavorite ? <HeartFilled style={{ color: '#ff4d4f' }} /> : <HeartOutlined />}
        onClick={(e) => onFavorite(e)}
        style={{
            position: 'absolute',
            top: 8,
            left: 8,
            padding: '2px',
            height: 'auto',
            width: 'auto',
            minWidth: 'auto',
            transform: isFavorite ? 'scale(1.1)' : 'scale(1)',
            transition: 'all 0.3s ease',
            background: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}
        className="lot-favorite"
        data-tour="lot-favorite"
    />
);

export default FavoriteButton;

